import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { useDevExtraHiveSnByLine } from '@/server';
import { MqttApi } from '@/utils/paho_mqtt';
import uuid from 'react-uuid';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'UPDATE_PARAM_STATISTIC',
    method: 'GET',
  });

  const page_uid = uuid();
  const [machid, setMachid] = useState();
  const [hiveSn, isHiveSnSuccess] = useDevExtraHiveSnByLine(machid);
  useEffect(() => {
    if (isHiveSnSuccess) {
      if (hiveSn) {
        if (hiveSn === 'hive_not_alive') {
          setIsSucc(true);
          setRsp([]);
          return;
        }
        MqttApi.subscriptionApi(
          {
            topic: 'param-update-rsp-' + hiveSn + '-' + page_uid,
          },
          res => {
            if (!res.data.error) {
              setIsSucc(true);
              setRsp(res.data.data);
            } else {
              setIsSucc(true);
              setRsp([]);
            }
          }
        );
        MqttApi.publishApi({
          topic: 'param-update-req-' + hiveSn,
          payload: {
            device_id: params.device_ids,
            start: params.start,
            end: params.end,
            id: page_uid,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hiveSn, isHiveSnSuccess]);

  const [rsp, setRsp] = useState([]);
  const [isSucc, setIsSucc] = useState();
  useEffect(() => {
    if (data) {
      setRsp(data);
      setIsSucc(isRequestSuccessed);
    }
  }, [data, isRequestSuccessed]);

  useEffect(() => {
    if (params) {
      if (params.isCloud) {
        setMachid({ device_id: params.device_ids });
      } else {
        let url = `/api/paramter/modify/statistics`;
        Object.keys(params).forEach((key, index) => {
          if (index === 0) {
            url += '?';
          } else {
            url += '&';
          }
          url += `${key}=${params[key]}`;
        });
        exec(url);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  //console.error('GETmain==>', JSON.stringify(data));
  return [isSucc, rsp || [], exec];
  // }
});
